import React from "react";
import HeroImg from "../../assets/images/internal_error.jpg";
import Link from "next/link";
import Image from "next/image";
import { Box, Button, Grid } from "@mui/material";
import { ServerErrorContainer } from "./ServerErrorStyle";

function ServerError({ onClick }: { onClick?: any }) {
  return (
    <ServerErrorContainer>
      <Box className="hero_container">
        <Grid className="w-100">
          <Grid
            md={6}
            className="d-flex justify-content-center align-items-center"
          >
            <Box className="hero_left">
              <Box className="hero_content">
                <h1 className="hero_heading">Sorry,</h1>
                <h6>Something went wrong</h6>
                <p>Please try after sometime</p>
                {onClick ? (
                  <button onClick={onClick} className="btn btn-light mb-2">
                    Retry
                  </button>
                ) : null}
                <Link href={"/"}>
                  <Button variant="contained">Back to Home</Button>
                </Link>
              </Box>
            </Box>
          </Grid>
          <Grid md={6} className="d-flex">
            <Box className="hero_right">
              <Image
                src={HeroImg}
                alt="somethig went wrong"
                className="img-fluid"
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ServerErrorContainer>
  );
}

export default ServerError;
